import './components/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import Registration from './components/Register/Registration';
import { Routes, Route, } from 'react-router-dom';
import Success from './pages/Success';
import Cancel from './pages/Cancel';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import UserDashboard from './pages/UserDashboard';
import { ProtectedRoute, AdminProtectedRoute } from './components/Protected/ProtectedRoute';
import NotFound from './pages/NotFound';
import CarePlan from './pages/CarePlans/CarePlan';
import UnlockDashboard from './pages/UnlockDashboard';
import ActiveCareGuard from './components/Protected/ActiveCareGuard';
import UserDashboardShell from './components/layout/UserDashboardShell';
import MyAccount from './pages/MyAccount';
import Payments from './pages/Payments';
import CareDetails from './pages/CareDetails';
import ClaimHistory from './pages/ClaimHistory';
import RaiseClaim from './pages/RaiseClaim';
import Support from './pages/Support';
import Shop from './pages/Shop';
import FAQHelp from './pages/FAQHelp';
import ReferAndEarn from './pages/ReferAndEarn';
import AdminLogin from './pages/AdminLogin';
import AdminMessage from './pages/AdminMessage';
import AdminPayment from './pages/AdminPayment';
import AdminPaymentById from './pages/AdminPaymentById';
import AdminReferAndEarn from './pages/AdminReferAndEarn';
import AdminReferAndEarnById from './pages/AdminReferAndEarnById';
import AdminClaim from './pages/AdminClaim';
import AdminDashboardShell from './components/layout/AdminDashboardShell';

import AdminFAQ from './pages/AdminFAQ';
import AdminCareers from './pages/AdminCareers';
import AdminTeam from './pages/AdminTeam';

function App() {

  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        autoDisplay: false
      },
      "google_translate_element"
    );
  };
  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    );
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;
  }, []);

  useEffect(() => {
    const moveTranslateWidget = () => {
      const translateEl = document.getElementById("google_translate_element");
      const navContainer =
        document.querySelector(".bev-hdr-translate") ||
        document.querySelector(".notification-container");

      if (translateEl && navContainer && !navContainer.contains(translateEl)) {
        navContainer.insertBefore(translateEl, navContainer.firstChild);
      }
    };

    moveTranslateWidget();

    const observer = new MutationObserver(moveTranslateWidget);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return (
          <>
          <Toaster position="top-right" />
          <div id="google_translate_element"></div>
      <Routes>
        <Route path='/' element={<Registration />} />
        <Route path='/login' element={<Login />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/user' element={<ProtectedRoute />}>
          <Route path='unlock-dashboard' element={<UnlockDashboard />} />
          <Route path='success' element={<Success />} />
          <Route path='cancel' element={<Cancel />} />
          <Route path='purchase-care-plan' element={<CarePlan />} />
          <Route element={<ActiveCareGuard />}>
            <Route element={<UserDashboardShell />}>
              <Route path='dashboard' element={<UserDashboard />} />
              <Route path='profile' element={<MyAccount />} />
              <Route path='payments' element={<Payments />} />
              <Route path='care-details' element={<CareDetails />} />
              <Route path='claim-history' element={<ClaimHistory />} />
              <Route path='raise-claim' element={<RaiseClaim />} />
              <Route path='support' element={<Support />} />
              <Route path='refer-and-earn' element={<ReferAndEarn />} />
              <Route path='shop' element={<Shop />} />
              <Route path='faq-help' element={<FAQHelp />} />
            </Route>
          </Route>
        </Route>
        <Route path='/admin/login' element={<AdminLogin />} />
        <Route path='/admin' element={<AdminProtectedRoute />}>
          <Route element={<AdminDashboardShell />}>
            <Route path='' element={<AdminMessage />} />
            <Route path='payments' element={<AdminPayment />} />
            <Route path='payments/:userId' element={<AdminPaymentById />} />
            <Route path='refer-and-earn' element={<AdminReferAndEarn />} />
            <Route path='refer-and-earn/:userId' element={<AdminReferAndEarnById />} />
            <Route path='claims' element={<AdminClaim />} />
            <Route path='faq-update' element={<AdminFAQ />} />
            <Route path='careers' element={<AdminCareers />} />
            <Route path='leadership-team' element={<AdminTeam />} />
          </Route>
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      </>
  );
}

export default App;
